import { render, staticRenderFns } from "./MemberViewMemberPlanCard.vue?vue&type=template&id=6a8dfef7"
import script from "./MemberViewMemberPlanCard.vue?vue&type=script&lang=js"
export * from "./MemberViewMemberPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports